module.exports = __webpack_public_path__ + "img/menu.e1b69a3c.svg";